/* WebComponentLabelPrinting component */
import {Component, Element, h, Listen, Method, Prop, State, Watch} from '@stencil/core';
import WebComponentLabelPrintingTsx from './templates/dia-label-printing';
import {
  AbstractComponent,
  AbstractHelpers,
  FontFaces,
  I18N,
  Router,
  RouterRoutable,
  RouterRouteRender
} from '@dia-ui/abstract';
import UtilLabelPrintApi from '@dia-ui/util_label-print-api';

import WebComponentLabelPrintingPrintTsx from "./templates/dia-label-printing-print";
import WebComponentLabelPrintingPrintListTsx from "./templates/dia-label-printing-printlist";
import WebComponentLabelPrintingLabelOverviewTsx from "./templates/dia-label-printing-label-overview";
import WebComponentLabelPrintingLabelCreateEditTsx from "./templates/dia-label-printing-label-create-edit";
import WebComponentLabelPrintingPageTemplateTsx from "./templates/dia-label-printing-page-template-overview";
import WebComponentLabelPrintingPageTemplateCreateEditTsx
  from "./templates/dia-label-printing-page-template-create-edit";
import {ValidateBefore, Validator} from "@dia-ui/behavior_validator";
import "@dia-ui/behavior_color-picker";
import "@dia-ui/behavior_image-zoom";
import "@dia-ui/behavior_select";
import "@dia-ui/behavior_ruler";
import printJS from "print-js-updated";
import UtilTimer from "@dia-ui/util_timer";
import {Components} from "../../../components";
import DiaDatatable = Components.DiaDatatable;

@Component({
  tag: 'dia-label-printing',
  styleUrl: './styles/dia-label-printing.scss',
  assetsDirs: [
    '../assets',
    '../../../behaviors/validator/assets'
  ],
  shadow: true
})
export class WebComponentLabelPrinting {
  /**
   * PARAMETERS
   * @private
   */
  public static PARAMETERS: any;

  /**
   * FROM_VALIDATE_DELAY_MILLISECONDS
   * @private
   */
  private static FROM_VALIDATE_DELAY_MILLISECONDS: number = 500;

  /**
   * FORM_IDENTIFIER_LABEL
   * @private
   */
  private static readonly FORM_IDENTIFIER_LABEL: string = "dia-label-printing-label";

  /**
   * FORM_IDENTIFIER_PRINT
   * @private
   */
  private static readonly FORM_IDENTIFIER_PRINT: string = "dia-label-printing-print";

  /**
   * FORM_IDENTIFIER_PRINTLIST
   * @private
   */
  private static readonly FORM_IDENTIFIER_PRINTLIST: string = "dia-label-printing-printlist";

  /**
   * FORM_IDENTIFIER_TEMPLATE
   * @private
   */
  private static readonly FORM_IDENTIFIER_TEMPLATE: string = "dia-label-printing-page-template";

  /**
   * AUTO_RENDER_TIMEOUT
   * @private
   */
  private static readonly AUTO_RENDER_TIMEOUT: number = 1250;

  /**
   * labelPrintApi
   * @private
   */
  private labelPrintApi: UtilLabelPrintApi;

  /**
   * dataTableArticlesHeader
   * @private
   */
  dataTableArticlesHeader: any;

  /**
   * dataTableArticlesColumns
   * @private
   */
  dataTableArticlesColumns = [
    {
      "select": 1,
      "hidden": true
    },
    {
      "select": 2,
      "cellClass": "data-action",
      "headerClass": "data-action",
      "render": (_data, _element, _rowIndex, _cellIndex, _row, _headings)=> {
        let headingId = _headings.findIndex((entry: any) => { return entry.data === this.I18N.t("ID"); });

        if (headingId === null) {
          console.error("heading missing in result, please check server side datatable result!");
          return;
        }

        let data = this.printListData && this.printListData.data ? this.getDataTableValueByKey(this.printListData.data, "id", _row[headingId].text) : undefined;

        return data ? `<button
            onClick="window.open('${data.link}', '_blank')"
            data-primary-dark
            data-icon-only
            data-small
        ><i data-dia-icon-before="view"></i></button>
        <button
            onClick="this.getRootNode().host.deleteArticle('${data.id}')"
            data-secondary-light
            data-icon-only
            data-small
        ><i data-dia-icon-before="remove"></i></button>` : ''
      }
    },
    {
      "select": 3,
      "cellClass": "data-image",
      "headerClass": "data-image",
      "render": (_data, _element, _rowIndex, _cellIndex, _row, _headings) => {
        let headingId = _headings.findIndex((entry: any) => { return entry.data === this.I18N.t("Nr"); });
        if (headingId === null) {
          console.error("heading missing in result, please check server side datatable result!");
          return;
        }

        let data = this.getDataTableValueByKey(this.printListData.data, "nr", _row[1].text);

        return `<img has="image-zoom" src="${data !== undefined ? data.image : ""}" />`
      }
    },
    {
      "select": 4,
      "cellClass": "data-text",
      "headerClass": "data-text"
    },
    {
      "select": 5,
      "cellClass": "data-id",
      "headerClass": "data-id"
    },
    {
      "select": 6,
      "hidden": true,
      "renderHeader": (_data, _element, _cellIndex) => {
        return `<button
            onClick="this.getRootNode().host.refreshPrintList()"
            data-secondary-light
            data-icon-only
            data-small
            title="${this.I18N.t("Tabelle erneut laden")}"
        ><i data-dia-icon-before="refresh"></i></button>
        <button
            onClick="this.getRootNode().host.deleteArticles()"
            data-secondary-light
            data-icon-only
            data-small
            data-delete-articles-button
            disabled
            title="${this.I18N.t("Alle markierten Artikel löschen")}"
        ><i data-dia-icon-before="remove"></i></button>`;
      }
    }
  ];

  /**
   * dataTableArticlesOptions
   * @private
   */
  dataTableArticlesOptions= {
    "columnOptions": {
      "swap": [2,6]
    },
    "perPage": 10,
    "labels": {
      "info": "{start} - {end} | {rows}"
    },
    scrollY: "calc(var(--dia-dialog-min-height) - var(--dia-header-height) - var(--dia-backend-footer-height) - var(--dia-breadcrumb-height) - 60px - 150px - 112px)"
  };

  /**
   * dataTableLabelsHeader
   * @private
   */
  dataTableLabelsHeader: any;

  /**
   * dataTableLabelsColumns
   * @private
   */
  dataTableLabelsColumns = [
    {
      "select": 0,
      "cellClass": "data-action",
      "headerClass": "data-action",
      "render": (_data, _element, _rowIndex, _cellIndex, _row, _headings) => {
        let headingId = _headings.findIndex((entry: any) => { return entry.data === this.I18N.t("Aktion"); });

        if (headingId === null) {
          console.error("heading missing in result, please check server side datatable result!");
          return;
        }

        let data = this.getDataTableValueByKey(this.labelOverviewData.data, "labelId", _row[headingId].text);
        if (data === undefined) {
          data = this.getDataTableValueByKey(this.labelOverviewData.data, "labelId", _data[0].data);
        }

        return data ? `<button
              ${data.noEdit ? "disabled" : ""}
              data-primary-dark
              data-icon-only
              data-small
              onClick="this.getRootNode().host.editLabel('${data.labelId}')"
          ><i data-dia-icon-before="edit"></i></button>
          <button
              ${data.noCopy ? "disabled" : ""}
              data-primary-dark
              data-icon-only
              data-small
              onClick="this.getRootNode().host.copyLabel('${data.labelId}')"
          ><i data-dia-icon-before="copy"></i></button>
          <button
              ${data.noDelete ? "disabled" : ""}
              data-secondary-light
              data-icon-only
              data-small
              onClick="this.getRootNode().host.deleteLabel('${data.labelId}')"
          ><i data-dia-icon-before="remove"></i></button>` : ''
      }
    },
    {
      "select": 1,
      "hidden": true
    },
    {
      "select": 2,
      "cellClass": "data-name",
      "headerClass": "data-name"
    },
    {
      "select": 3,
      "cellClass": "data-used",
      "headerClass": "data-used"
    },
    {
      "select": 4,
      "cellClass": "data-width",
      "headerClass": "data-width",
      "render": (_data, _element, _rowIndex, _cellIndex) => {
        return _data[0].data + "mm";
      }
    },
    {
      "select": 5,
      "cellClass": "data-height",
      "headerClass": "data-height",
      "render": (_data, _element, _rowIndex, _cellIndex) => {
        return _data[0].data + "mm";
      }
    },
    {
      "select": 6,
      "hidden": true
    },
    {
      "select": 7,
      "hidden": true
    },
    {
      "select": 8,
      "hidden": true
    },
    {
      "select": 9,
      "hidden": true
    }
  ];

  /**
   * dataTableLabelsOptions
   * @private
   */
  dataTableLabelsOptions= {
    "columnOptions": {
      "swap": [0,6]
    },
    "perPage": 10,
    "labels": {
      "info": "{start} - {end} | {rows}"
    },
    scrollY: "calc(var(--dia-dialog-min-height) - var(--dia-header-height) - var(--dia-backend-footer-height) - var(--dia-breadcrumb-height) - 210px)"
  };

  /**
   * dataTableTemplatesHeader
   * @private
   */
  dataTableTemplatesHeader: any;

  /**
   * dataTableTemplatesColumns
   * @private
   */
  dataTableTemplatesColumns= [
    {
      "select": 0,
      "cellClass": "data-action",
      "headerClass": "data-action",
      "render": (_data, _element, _rowIndex, _cellIndex, _row, _headings) => {
        let headingId = _headings.findIndex((entry: any) => { return entry.data === this.I18N.t("ID"); });

        if (headingId === null) {
          console.error("heading missing in result, please check server side datatable result!");
          return;
        }

        let data = this.getDataTableValueByKey(this.pageTemplateOverviewData.data, "templateId", _row[headingId].text);
        if (data === undefined) {
          data = this.getDataTableValueByKey(this.pageTemplateOverviewData.data, "templateId", _data[0].data);
        }

        return data ? `<button
              ${data.noEdit ? "disabled" : ""}
              data-primary-dark
              data-icon-only
              data-small
              onClick="this.getRootNode().host.editPageTemplate('${data.templateId}')"
          ><i data-dia-icon-before="edit"></i></button>
          <button
              ${data.noCopy ? "disabled" : ""}
              data-primary-dark
              data-icon-only
              data-small
              onClick="this.getRootNode().host.copyPageTemplate('${data.templateId}')"
          ><i data-dia-icon-before="copy"></i></button>
          <button
              ${data.noDelete ? "disabled" : ""}
              data-secondary-light
              data-icon-only
              data-small
              onClick="this.getRootNode().host.deletePageTemplate('${data.templateId}')"
          ><i data-dia-icon-before="remove"></i></button>` : ''
      }
    },
    {
      "select": 1,
      "hidden": true
    },
    {
      "select": 2,
      "cellClass": "data-name",
      "headerClass": "data-name"
    },
    {
      "select": 3,
      "cellClass": "data-used",
      "headerClass": "data-used"
    },
    {
      "select": 4,
      "cellClass": "data-width",
      "headerClass": "data-width",
      "render": (_data, _element, _rowIndex, _cellIndex)=> {
        return _data[0].data + "mm";
      }
    },
    {
      "select": 5,
      "cellClass": "data-height",
      "headerClass": "data-height",
      "render": (_data, _element, _rowIndex, _cellIndex) => {
        return _data[0].data + "mm";
      }
    },
    {
      "select": 6,
      "hidden": true
    },
    {
      "select": 7,
      "hidden": true
    },
    {
      "select": 8,
      "hidden": true
    },
    {
      "select": 9,
      "hidden": true
    }
  ];

  /**
   * dataTableTemplatesOptions
   * @private
   */
  dataTableTemplatesOptions= {
    "columnOptions": {
      "swap": [0, 6]
    },
    "perPage": 10,
    "labels": {
      "info": "{start} - {end} | {rows}"
    },
    scrollY: "calc(var(--dia-dialog-min-height) - var(--dia-header-height) - var(--dia-backend-footer-height) - var(--dia-breadcrumb-height) - 210px)"
  };

  /**
   * getDataTableValueByKey
   * @param data
   * @param key
   * @param value
   * @private
   */
  private getDataTableValueByKey(data: any, key: string, value: any) {
    return data.find((entry: any) => {
      return String(entry[key]) === String(value);
    });
  }

  /**
   * i18n
   */
  @I18N()
  /**
   * router
   */
  @Router({
    'ROOT': {
      pattern: '/',
      render: WebComponentLabelPrintingPrintListTsx,
      properties: (context) => { return { 'title': context.ref.I18N.t('Druckliste'), 'icon': 'print' } },
      exact: true
    },
    'PRINT': {
      pattern: '/print',
      render: WebComponentLabelPrintingPrintTsx,
      properties: (context) => { return { 'title': context.ref.I18N.t('Vorschau & Drucken'), 'icon': 'print' } },
      exact: true
    },
    'PRINTLIST': {
      pattern: '/printlist',
      render: WebComponentLabelPrintingPrintListTsx,
      properties: (context) => { return { 'title': context.ref.I18N.t('Druckliste'), 'icon': 'print' } },
      exact: true
    },
    'LABEL_OVERVIEW': {
      pattern: '/label-overview',
      render: WebComponentLabelPrintingLabelOverviewTsx,
      properties: (context) => { return { 'title': context.ref.I18N.t('Etiketten Übersicht'), 'icon': 'table' } },
      exact: true
    },
    'LABEL_CREATE': {
      pattern: '/label-create',
      render: WebComponentLabelPrintingLabelCreateEditTsx,
      properties: (context) => { return { 'title': context.ref.I18N.t('Etikett erstellen'), 'icon': 'edit' } },
      exact: true
    },
    'LABEL_EDIT': {
      pattern: '/label-edit/:id',
      render: WebComponentLabelPrintingLabelCreateEditTsx,
      properties: (context) => { return { 'title': context.ref.I18N.t('Etikett bearbeiten'), 'icon': 'edit' } }
    },
    'PAGE_TEMPLATE_OVERVIEW': {
      pattern: '/page-template-overview',
      render: WebComponentLabelPrintingPageTemplateTsx,
      properties: (context) => { return { 'title': context.ref.I18N.t('Druckvorlagen Übersicht'), 'icon': 'table' } },
      exact: true
    },
    'PAGE_TEMPLATE_CREATE': {
      pattern: '/page-template-create',
      render: WebComponentLabelPrintingPageTemplateCreateEditTsx,
      properties: (context) => { return { 'title': context.ref.I18N.t('Druckvorlagen erstellen'), 'icon': 'edit' } },
      exact: true
    },
    'PAGE_TEMPLATE_EDIT': {
      pattern: '/page-template-edit/:id',
      render: WebComponentLabelPrintingPageTemplateCreateEditTsx,
      properties: (context) => { return { 'title': context.ref.I18N.t('Druckvorlagen bearbeiten'), 'icon': 'edit' } }
    },
  })
  /**
   * font faces
   */
  @FontFaces()
  /**
   * element
   */
  @Element()
  element: HTMLElement;

  /**
   * useStandalone
   */
  @Prop({reflect: true}) useStandalone: boolean = false;

  /**
   * useRouter
   */
  @Prop({reflect: true}) useRouter: boolean = false;

  /**
   * showStandalone
   */
  @Prop({reflect: true}) showStandalone: boolean = false;

  /**
   * opened
   */
  @Prop({reflect: true}) opened: boolean = false;

  /**
   * apiHost
   */
  @Prop() apiHost: string = "http://localhost:30400/_source/rest/";

  /**
   * panelHeaderIcon
   */
  @State() panelHeaderIcon: string = "edit";

  /**
   * panelHeaderTitle
   */
  @State() panelHeaderTitle: string = "";

  /**
   * labelData
   */
  @State() labelData: any;

  /**
   * labelTemplates
   */
  @State() labelTemplates: any;

  /**
   * printListData
   */
  @State() printListData: any = [];

  /**
   * printListChoice
   */
  @State() printListChoice: any = [];

  /**
   * printPageTemplateData
   */
  @State() printPageTemplateData: any = [];

  /**
   * printPageMaxLabelCountPerSheet
   */
  @State() printPageMaxLabelCountPerSheet: number = 1;

  /**
   * labelOverviewData
   */
  @State() labelOverviewData: any = [];

  /**
   * pageTemplateData
   */
  @State() pageTemplateData: any;

  /**
   * pageTemplateData
   */
  @State() pageTemplateDataFormat: any;

  /**
   * pageTemplateOverviewData
   */
  @State() pageTemplateOverviewData: any = [];

  /**
   * pageFormat
   */
  @State() pageFormat: string;

  /**
   * labelPreview
   */
  @State() labelPreview: any;

  /**
   * templatePreview
   */
  @State() templatePreview: any;

  /**
   * labelType
   */
  @State() labelType: any;

  /**
   * labelTypeData
   */
  @State() labelTypeData: any;

  /**
   * labelDisplayType
   */
  @State() labelDisplayType: any;

  /**
   * labelDisplayTypeOption
   */
  @State() labelDisplayTypeOption: any;

  /**
   * labelItems
   */
  @State() labelItems: any;

  /**
   * labelItem
   */
  @State() labelItem: any;

  /**
   * labelItemData
   */
  @State() labelItemData: any;

  /**
   * labelItemDataEntries
   */
  labelItemDataEntries: [];

  /**
   * labelItemIndex
   */
  labelItemIndex: number;

  /**
   * invalidItems
   */
  @State() invalidItems = [];

  /**
   * loading progress in percent
   * @type {number}
   */
  @State() loadingProgress: number = 0;

  /**
   * loading indicator
   * @type {boolean}
   */
  @State() loading: boolean = false;

  /**
   * loadingStack
   */
  loadingStack = [];

  /**
   * loadingState
   * @type {boolean}
   */
  @State() loadingState: string;

  /**
   * loadingMessage
   */
  @State() loadingMessage: string;

  /**
   * loadingInformation
   */
  @State() loadingInformation: string;

  /**
   * error indicator
   * @type {boolean}
   */
  @State() error: boolean = false;

  /**
   * pdfPreviewTemplate
   * @type {string}
   */
  @State() pdfPreviewTemplate: string;

  /**
   * labelPrintApiFetchError
   * @param event
   */
  @Listen("label-print-api:fetch:error", { target: "window" })
  @Listen("labelPrintingTemplateOverview:fetch:error", { target: "window" })
  @Listen("labelPrintingLabelOverview:fetch:error", { target: "window" })
  @Listen("labelPrintingPrintList:fetch:error", { target: "window" })
  labelPrintApiFetchError(event) {
    this.error = true;
    this.loadingMessage = event.detail.error;
    this.loadingInformation = event.detail.url;
    this.loadingState = "error";
  }

  /**
   * expertMode
   * @type {boolean}
   */
  @State() expertMode: boolean = false;

  /**
   * expertModeVisible
   * @type {boolean}
   */
  @Prop() expertModeVisible: boolean = false;

  /**
   * expertModeActive
   * @type {boolean}
   */
  @Prop() expertModeActive: boolean = false;

  /**
   * featureResult
   */
  @State() featureResult: any;

  /**
   * printLabelTemplatePreview
   */
  @State() printLabelTemplatePreview: any;

  /**
   * printLabelTemplateChoosen
   */
  @State() printLabelTemplateChoosen: string;

  /**
   * pdfPreview
   */
  @State() pdfPreview: any;

  /**
   * labelPrintingPageTemplateFormValid
   */
  @State() labelPrintingLabelFormValid: boolean;

  /**
   * labelPrintingPageTemplateFormValid
   */
  @State() labelPrintingPageTemplateFormValid: boolean;

  /**
   * labelPrintingPrintListFormValid
   */
  @State() labelPrintingPrintListFormValid: boolean;

  /**
   * labelPrintingPrintFormValid
   */
  @State() labelPrintingPrintFormValid: boolean;

  /**
   * STENCIL_ROUTER_IS_ACTIVE
   */
  @State() STENCIL_ROUTER_IS_ACTIVE: boolean = false;

  /**
   * previewHandlerRunning
   */
  previewHandlerRunning: boolean = false;

  /**
   * previewTemplateHandlerRunning
   */
  previewTemplateHandlerRunning: boolean = false;

  /**
   * lastRenderItem
   */
  lastRenderItem: any;

  /**
   * templateLabelWidth
   */
  @State() templateLabelWidth: number;
  templateLabelWidthOld: number;

  /**
   * templateLabelHeight
   */
  @State() templateLabelHeight: number;
  templateLabelHeightOld: number;

  /**
   * templateId
   */
  @State() templateId: number = 0;
  templateIdOld: number = 0;

  @Watch('expertModeActive')
  changeExpertModeActive() {
    this.expertMode = this.expertModeActive;
  }

  /**
   * open
   */
  @Method()
  async open() {
    this.opened = true;

    // @ts-ignore
    this.element.shadowRoot.querySelector('dialog').setAttribute("open", true);

    let route = 'dia-label-printing/';
    if (window.location.href.indexOf(route) === -1) {
      window.location.href = window.location.href + (window.location.href.indexOf('#') !== -1 ? '' : '#/') + route;
    }

    this.setRouterIsActive(true);

    let routeString = this.getRouterRoute('PRINTLIST');
    this.pushRouterRoute(routeString);
    this.reloadRouterRoute(routeString);

    this.getScrollBlocker().lock();
    this.changeExpertModeActive();
  }

  /**
   * close
   * @param event
   */
  @Method()
  async close(event) {
    this.opened = false;

    event.preventDefault();

    this.element.shadowRoot.querySelector('dialog').close();
    this.setRouterIsActive(false);
    this.pushRouterRoute(this.getRouterRoute('PRINTLIST'));

    this.getScrollBlocker().reset();
  }

  /**
   * constructor
   */
  constructor() {
    this.labelPrintApi = new UtilLabelPrintApi(this.apiHost);
  }

  /**
   * toggleExpertMode
   * @param event
   */
  toggleExpertMode(event) {
    if (event.target.checked === true) {
      if (!confirm(this.I18N.t("Wollen Sie wirklich in den Experten-Modus wechseln?"))) {
        event.target.checked = false;
        return;
      }
    }

    let redirect = false;
    if (event.target.checked === false && window.location.href.indexOf("/page-template-") !== -1) {
      if (!confirm(this.I18N.t("Wollen Sie den Experten-Modus wirklich verlassen? Ihre nicht gespeicherten Änderungen gehen verloren und Sie verlassen den Menüpunkt -> Druckvorlagen!"))) {
        event.target.checked = true;
        return;
      }
      redirect = true;
    }

    this.expertMode = event.target.checked;
    this.expertModeActive = event.target.checked;

    if (redirect) {
      this.pushRouterRoute(this.getRouterRoute('ROOT'));
    }
  }

  /**
   * submitPrintList
   */
  @Method()
  @ValidateBefore(WebComponentLabelPrinting.FORM_IDENTIFIER_PRINTLIST, WebComponentLabelPrinting.FROM_VALIDATE_DELAY_MILLISECONDS)
  async submitPrintList() {
    this.pushRouterRoute(this.getRouterRoute('PRINT'));
  }

  /**
   * printListChoiceUpdate
   */
  @Watch('printListChoice')
  async printListChoiceUpdate() {
    window.dispatchEvent(new CustomEvent("DataTable:labelPrintingPrintList:checkbox:update", {
      detail: this.printListData && this.printListData.data ? this.printListData.data
        .filter(entry => this.printListChoice.includes(entry.id))
        .map(entry => entry.id) : []
    }));

    await Validator.validate(WebComponentLabelPrinting.FORM_IDENTIFIER_PRINTLIST, WebComponentLabelPrinting.FROM_VALIDATE_DELAY_MILLISECONDS);
  }

  /**
   * printListChoiceChange
   */
  @Listen("DataTable:labelPrintingPrintList:checkbox:change", { target: "window" })
  printListChoiceChange(event) {
    let choiceEntryArray = event.detail.entries || [],
      choiceIndexArrayIds = this.printListData && this.printListData.data ? choiceEntryArray.map(entry => (this.printListData.data.find((data) => data["nr"] === entry[0])).id) : [];

    this.printListChoice = [...choiceIndexArrayIds];

    // @ts-ignore
    let deleteAllButton = this.element.shadowRoot.querySelector('button[data-delete-articles-button]');

    if (deleteAllButton && this.printListChoice.length === 0) {
      deleteAllButton.setAttribute("disabled", "disabled");
    } else if (deleteAllButton && this.printListChoice.length > 0) {
      deleteAllButton.removeAttribute("disabled");
    }
  }

  /**
   * printListChoiceChangeAll
   */
  @Listen("DataTable:labelPrintingPrintList:checkbox:change:all", { target: "window" })
  printListChoiceChangeAll() {
    let choiceIndexArrayIds = this.printListData && this.printListData.data ? this.printListData.data.map(entry => entry.id) : [];

    this.printListChoice = [];
    this.printListChoice = [...this.printListChoice, ...choiceIndexArrayIds];

    // @ts-ignore
    let deleteAllButton = this.element.shadowRoot.querySelector('button[data-delete-articles-button]');

    if (deleteAllButton && this.printListChoice.length === 0) {
      deleteAllButton.setAttribute("disabled", "disabled");
    } else if (deleteAllButton && this.printListChoice.length > 0) {
      deleteAllButton.removeAttribute("disabled");
    }
  }

  /**
   * updatePanelHeaderIcon
   * @param icon
   * @protected
   */
  protected updatePanelHeaderIcon(icon: string): void {
    this.panelHeaderIcon = icon;
  }

  /**
   * updatePanelHeaderTitle
   * @param title
   * @protected
   */
  protected updatePanelHeaderTitle(title: string): void {
    this.panelHeaderTitle = title;
  }

  /**
   * updateItemData
   * @param updateItem
   * @private
   */
  private async updateItemData(updateItem: boolean = true) {
    let serviceItem = this.labelPrintApi.getServiceItem(),
      itemId = this.labelItem && this.labelItem['item-id'] ? this.labelItem['item-id'] : null;

    if (this.labelTypeData === "" && (this.labelItem && this.labelItem['item-json'] && this.labelItem['item-json']['source-id'] !== "")) {
      this.labelTypeData = this.labelItem['item-json']['source-id'];
    }

    this.labelItemData = await serviceItem.get({
      "source-type": this.labelType,
      "source-id": this.labelTypeData,
      "display-type": this.labelDisplayType,
      "display-type-sub-option": this.labelDisplayTypeOption
    }, this.templateId, itemId);

    this.labelItemDataEntries = {...this.labelItemDataEntries, ...this.labelItemData.entries};

    if (updateItem && itemId == null) {
      this.labelItem = {"item-json":{}};

      // check every default value for empty field end set if needed
      for (const [field, value] of Object.entries(this.labelItemData.entityValues)) {
        if (this.labelItem && this.labelItem["item-json"]) {
          if (
            this.labelItem["item-json"][field] === "" ||
            this.labelItem["item-json"][field] === undefined ||
            this.labelItem["item-json"][field] == null
          ) {
            this.labelItem["item-json"][field] = value;
          }
        }
      }
    }

    this.labelData = {...this.labelData, ...this.labelItemData};
  }

  /**
   * resetItemForm
   * @param event
   */
  async resetItemForm(event?) {
    if (event) {
      event.preventDefault();
    }

    Validator.reset(WebComponentLabelPrinting.FORM_IDENTIFIER_LABEL);
    Validator.skipNext();

    await this.onChangeDisplayType();

    this.labelType = "text";
    this.labelTypeData = null;
    this.labelDisplayType = "text";
    this.labelDisplayTypeOption = null;

    this.labelItem = null;
    this.labelItemIndex = null;
    this.labelItemData = null;
  }

  /**
   * changePageFormat
   * @param format
   */
  async changePageFormat(format) {
    let pageFormat = Array.from(format.target.querySelectorAll("option"))
      // @ts-ignore
      .filter((option: HTMLOptionElement) => option.selected)[0].value;

    let serviceTemplate = this.labelPrintApi.getServiceTemplate();

    Validator.skipNext();

    // @ts-ignore
    this.pageTemplateData = await serviceTemplate.get();
    this.pageTemplateData['template-json']['page-format'] = pageFormat;
    this.pageTemplateData['template-json']['label-nr-x'] = 0;
    this.pageTemplateData['template-json']['label-nr-y'] = 0;
    this.pageTemplateData['template-json']['label-distance-x'] = 0;
    this.pageTemplateData['template-json']['label-distance-y'] = 0;
    this.pageFormat = pageFormat;
    this.templatePreview = "";
  }

  /**
   * onChangeType
   * @param event
   */
  async onChangeType(event) {
    Validator.skipNext();
    this.labelType = event.target.value;

    if (this.labelType === "feature") {
      Validator.skipNext();
      await this.searchFeature();
    }

    Validator.skipNext();
    await this.updateItemData();

    this.labelTypeData = this.labelData['source-id']
    || this.labelData.entityValues['source-type'] === this.labelType ? this.labelData.entityValues['source-id'] : "";
    this.labelDisplayType = this.labelData['display-type']
    || this.labelData.entityValues['source-type'] === this.labelType ? this.labelData.entityValues['display-type'] : "text";
    this.labelDisplayTypeOption = this.labelData['display-type-sub-option']
    || this.labelData.entityValues['source-type'] === this.labelType ? this.labelData.entityValues['display-type-sub-option'] : "" || null;

    await Validator.validate(WebComponentLabelPrinting.FORM_IDENTIFIER_LABEL,
      WebComponentLabelPrinting.FROM_VALIDATE_DELAY_MILLISECONDS);
  }

  /**
   * onChangeDisplayType
   * @param event
   */
  async onChangeDisplayType(event?) {
    if (event && this.labelDisplayType === event.target.value) return;
    if (event) {
      this.labelDisplayType = event.target.value;
    }

    this.labelTypeData = this.labelData['source-id']
    || this.labelData.entityValues['source-type'] === this.labelType ? this.labelData.entityValues['source-id'] : "";
    this.labelDisplayTypeOption = this.labelData['display-type-sub-option']
    || this.labelData.entityValues['display-type'] === this.labelDisplayType ? this.labelData.entityValues['display-type-sub-option'] : "" || null;

    await this.updateItemData();

    await Validator.validate(WebComponentLabelPrinting.FORM_IDENTIFIER_LABEL,
      WebComponentLabelPrinting.FROM_VALIDATE_DELAY_MILLISECONDS);
  }

  /**
   * onChangeDisplayTypeOption
   * @param event
   */
  async onChangeDisplayTypeOption(event) {
    this.labelDisplayTypeOption = event.target.value;

    this.labelTypeData = this.labelData['source-id']
    || this.labelData.entityValues['source-type'] === this.labelType ? this.labelData.entityValues['source-id'] : "";

    await this.updateItemData();

    await Validator.validate(WebComponentLabelPrinting.FORM_IDENTIFIER_LABEL,
      WebComponentLabelPrinting.FROM_VALIDATE_DELAY_MILLISECONDS);
  }

  /**
   * onChangeTypeData
   * @param event
   */
  async onChangeTypeData(event) {
    this.labelTypeData = event.target.value;

    if (this.labelData && this.labelTypeData && this.labelData.entries && this.labelData.entries[this.labelTypeData] && !this.labelData.entries[this.labelTypeData].displayTypes.includes(this.labelDisplayType)) {
      this.labelDisplayType = this.labelData.entries[this.labelTypeData].displayTypes[0];
    }

    await this.updateItemData();

    await Validator.validate(WebComponentLabelPrinting.FORM_IDENTIFIER_LABEL,
      WebComponentLabelPrinting.FROM_VALIDATE_DELAY_MILLISECONDS);
  }

  /**
   * Called every time the component is connected to the DOM.
   * When the component is first connected, this method is called before componentWillLoad.
   * It's important to note that this method can be called more than once, everytime, the element is attached or moved in the DOM.
   * This lifecycle hook follows the same semantics as the one described by the Custom Elements Spec
   */
  connectedCallback() {
  }

  /**
   * Called every time the component is disconnected from the DOM, ie, it call be dispatched more than once
   * DO not confuse with a "onDestroy" kind of event.
   * This lifecycle hook follows the same semantics as the one described by the Custom Elements Spec.
   */
  disconnectedCallback() {
  }

  /**
   * Called once just after the component is first connected to the DOM.
   * A promise can be returned, that can be used to wait for the first render.
   */
  componentWillLoad() {/**
   * dataTableArticlesHeader
   */
  this.dataTableArticlesHeader = [
    {"text": this.I18N.t("Nr"), "value": "nr", "searchable": "true"},
    {"text": this.I18N.t("ID"), "value": "id"},
    {"text": this.I18N.t("Artikelbild"), "value": "image", "aggregated": "true"},
    {"text": this.I18N.t("Artikelbezeichnung"), "value": "descShort", "aggregated": "true", "searchable": "true"},
    {"text": this.I18N.t("Artikelnummer"), "value": "number", "aggregated": "true"},
    {"text": this.I18N.t("Aktion"), "value": "link", "aggregated": "true"}
  ];

    /**
     * dataTableTemplatesHeader
     */
    this.dataTableTemplatesHeader = [
      {"text": this.I18N.t("ID"), "value": "templateId"},
      {"text": this.I18N.t("Label ID"), "value": "labelId"},
      {"text": this.I18N.t("Name"), "value": "templateDesc", "searchable": "true"},
      {"text": this.I18N.t("Verwendet von"), "value": "labelDesc", "searchable": "true"},
      {"text": this.I18N.t("Breite"), "value": "width", "aggregated": "true"},
      {"text": this.I18N.t("Höhe"), "value": "height", "aggregated": "true"},
      {"text": this.I18N.t("Aktion"), "value": "ownerId", "aggregated": "true"},
      {"text": "noEdit", "value": "noEdit", "aggregated": "true"},
      {"text": "noCopy", "value": "noCopy", "aggregated": "true"},
      {"text": "noDelete", "value": "noDelete", "aggregated": "true"}
    ];

    /**
     * dataTableLabelsHeader
     */
    this.dataTableLabelsHeader = [
      {"text": this.I18N.t("Aktion"), "value": "labelId", "sortable": "true"},
      {"text": this.I18N.t("Template ID"), "value": "templateId"},
      {"text": this.I18N.t("Name"), "value": "labelDesc", "searchable": "true"},
      {"text": this.I18N.t("Druckvorlage"), "value": "templateDesc", "searchable": "true"},
      {"text": this.I18N.t("Breite"), "value": "width", "aggregated": "true"},
      {"text": this.I18N.t("Höhe"), "value": "height", "aggregated": "true"},
      {"text": "Owner", "value": "ownerId", "aggregated": "true", "sortable": "true"},
      {"text": "noEdit", "value": "noEdit", "aggregated": "true"},
      {"text": "noCopy", "value": "noCopy", "aggregated": "true"},
      {"text": "noDelete", "value": "noDelete", "aggregated": "true"}
    ];
  }

  /**
   * Called once just after the component fully loaded and the first render() occurs.
   */
  componentDidLoad() {
    this.setRouterIsActive(false);

    this.pushRouterRoute(this.getRouterRoute('ROOT'));
  }

  /**
   * Called before every render().
   * A promise can be returned, that can be used to wait for the upcoming render.
   */
  componentWillRender() {
  }

  /**
   * Called after every render().
   */
  componentDidRender() {
    if (this.labelType !== "feature") {
      let garbage = this.element.shadowRoot.querySelector('[name="source-id"]');

      if(garbage && garbage.nextElementSibling && garbage.nextElementSibling.classList.contains("ts-wrapper")) {
        garbage.nextElementSibling.remove();
      }
    }
  }

  /**
   * Called when the component is about to be updated because some Prop() or State() changed.
   * It's never called during the first render().
   * A promise can be returned, that can be used to wait for the next render.
   */
  componentWillUpdate() {
  }

  /**
   * Called just after the component updates. It's never called during the first render().
   */
  componentDidUpdate() {
  }

  /**
   * listen to the label print api fetch progress start
   */
  @Listen("DataTable:labelPrintingTemplateOverview:perpage:load:start", { target: "window" })
  @Listen("DataTable:labelPrintingLabelOverview:perpage:load:start", { target: "window" })
  @Listen("DataTable:labelPrintingPrintList:perpage:load:start", { target: "window" })
  @Listen("DataTable:labelPrintingTemplateOverview:page:load:start", { target: "window" })
  @Listen("DataTable:labelPrintingLabelOverview:page:load:start", { target: "window" })
  @Listen("DataTable:labelPrintingPrintList:page:load:start", { target: "window" })
  @Listen("label-print-api:progress:start", { target: "window" })
  labelPrintApiProgressStart() {
    this.loading = true;
    this.loadingStack.push(this.loading);
  }

  /**
   * listen to the label print api fetch progress end
   */
  @Listen("DataTable:labelPrintingTemplateOverview:perpage:load:end", { target: "window" })
  @Listen("DataTable:labelPrintingLabelOverview:perpage:load:end", { target: "window" })
  @Listen("DataTable:labelPrintingPrintList:perpage:load:end", { target: "window" })
  @Listen("DataTable:labelPrintingTemplateOverview:page:load:end", { target: "window" })
  @Listen("DataTable:labelPrintingLabelOverview:page:load:end", { target: "window" })
  @Listen("DataTable:labelPrintingPrintList:page:load:end", { target: "window" })
  @Listen("label-print-api:progress:end", { target: "window" })
  labelPrintApiProgressEnd(){
    this.loadingStack.pop();

    if (this.loadingStack.length === 0) {
      this.loading = false;
    }
  }

  /**
   * listen to the label print api fetch progress and refresh variable with current progress value
   * @param progress
   */
  @Listen("label-print-api:progress", { target: "window" })
  labelPrintApiProgress(progress){
    this.loadingProgress = progress.detail.value;
  }

  /**
   * renderRoute
   * @param properties
   */
  @RouterRouteRender()
  renderRoute(properties: any){
    this.updatePanelHeaderTitle(properties.title);
    this.updatePanelHeaderIcon(properties.icon);
  }

  /**
   * renderRoutePrintList
   */
  @RouterRouteRender('ROOT')
  @RouterRouteRender('PRINTLIST')
  async renderRoutePrintList(){
    this.printListData = undefined;

    setTimeout(async () => {
      let serviceArticle = this.labelPrintApi.getServiceArticle();

      this.printListData = await serviceArticle.getAll();
      this.printListData = { ...this.printListData };

      await this.printListChoiceUpdate();
    }, 500);
  }

  /**
   * refreshPrintList
   */
  @Method()
  async refreshPrintList() {
    let serviceArticle = this.labelPrintApi.getServiceArticle();

    this.printListData = undefined;

    setTimeout(async () => {
      this.printListData = await serviceArticle.getAll();
      this.printListData = { ...this.printListData };

      this.reloadRouterRoute(this.getRouterRoute('PRINTLIST'));
    }, 500);
  }

  /**
   * deleteArticle
   * @param id
   */
  @Method()
  async deleteArticle(id: string){
    if (confirm(this.I18N.t("Artikel wirklich löschen?"))) {

      let serviceArticle = this.labelPrintApi.getServiceArticle();

      await serviceArticle.delete(id);

      setTimeout(async () => {
        this.printListData = undefined;

        await this.refreshPrintList();
        await this.printListChoiceUpdate();
      }, 500);
    }
  }

  /**
   * deleteArticles
   * @param ids
   */
  @Method()
  async deleteArticles(ids: number[] = []){
    if (confirm(this.I18N.t("Wirklich alle markierten Artikel löschen?"))) {
      let chosenIds = this.printListData && this.printListData.data ? this.printListData.data
          .filter(entry => this.printListChoice.includes(entry.id))
          .map(entry => this.printListData.data.indexOf(entry)) : [],
        deleteIds = this.printListData && this.printListData.data ? [...chosenIds, ...ids].map(index => this.printListData.data[index].id) : [];

      let serviceArticle = this.labelPrintApi.getServiceArticle();

      await serviceArticle.delete(deleteIds);

      this.reloadRouterRoute(this.getRouterRoute('PRINTLIST'));

      setTimeout(async () => {
        await this.printListChoiceUpdate();
      }, 500);
    }
  }

  /**
   * renderRoutePrint
   */
  @RouterRouteRender('PRINT')
  async renderRoutePrint() {
    let serviceLabel = this.labelPrintApi.getServiceLabel();

    this.labelOverviewData = await serviceLabel.getAll();
    this.setPdfPreviewData({});

    if (this.labelOverviewData
      && this.labelOverviewData.data
      && this.labelOverviewData.data.length === 0
      && window.location.href.indexOf("/print") !== -1
    ) {
      if (confirm(this.I18N.t("Sie haben kein Etikett angelegt, möchten Sie eins anlegen?"))) {
        this.pushRouterRoute(this.getRouterRoute('LABEL_CREATE'));
      } else {
        this.pushRouterRoute(this.getRouterRoute('PRINT'));
        await Validator.validate(WebComponentLabelPrinting.FORM_IDENTIFIER_PRINT, WebComponentLabelPrinting.FROM_VALIDATE_DELAY_MILLISECONDS);
      }
    } else {
      await Validator.validate(WebComponentLabelPrinting.FORM_IDENTIFIER_PRINT, WebComponentLabelPrinting.FROM_VALIDATE_DELAY_MILLISECONDS);
    }
  }

  @Listen("dia-label-printing-label:validate", { target: "window" })
  labelPrintingLabelValidateHandler(event) {
    this.labelPrintingLabelFormValid = !!event.detail.valid;
  }

  @Listen("dia-label-printing-page-template:validate", { target: "window" })
  labelPrintingPageTemplateFormValidateHandler(event) {
    this.labelPrintingPageTemplateFormValid = !!event.detail.valid;
  }

  @Listen("dia-label-printing-printlist:validate", { target: "window" })
  labelPrintingPrintListFormValidateHandler(event) {
    this.labelPrintingPrintListFormValid = !!event.detail.valid;
  }

  @Listen("dia-label-printing-print:validate", { target: "window" })
  labelPrintingPrintFormValidateHandler(event) {
    this.labelPrintingPrintFormValid = !!event.detail.valid;
  }

  /**
   * printPDF
   */
  @Method()
  @ValidateBefore(WebComponentLabelPrinting.FORM_IDENTIFIER_PRINT, WebComponentLabelPrinting.FROM_VALIDATE_DELAY_MILLISECONDS)
  async printPDF() {
    let serviceLabel = this.labelPrintApi.getServiceLabel(),
      pdf = await serviceLabel.pdf(WebComponentLabelPrinting.PARAMETERS);

    printJS({
      printable: pdf.src.replace("data:application/pdf;base64,", ""),
      type: 'pdf',
      base64: true
    });
  }

  /**
   * changePdfPreview
   * @param target
   */
  async changePdfPreview(target){
    if (
      this.pdfPreview
      && this.printPageMaxLabelCountPerSheet !== this.pdfPreview.labelsPerSheetCount
      && this.pdfPreview.labelsPerSheetCount > 1
    ) {
      this.printPageMaxLabelCountPerSheet = this.pdfPreview.labelsPerSheetCount;
    }

    if (target.nodeName === "SELECT") {
      if (WebComponentLabelPrinting.PARAMETERS === undefined) {
        WebComponentLabelPrinting.PARAMETERS = {
          'start-position': 1
        }
      } else {
        WebComponentLabelPrinting.PARAMETERS['start-position'] = 1;
      }

      this.setPdfPreviewData({});
    }

    // if the print form is not valid reset preview data
    let validate= await Validator.validate(WebComponentLabelPrinting.FORM_IDENTIFIER_PRINT, WebComponentLabelPrinting.FROM_VALIDATE_DELAY_MILLISECONDS);
    if (!validate) {
      this.setPdfPreviewData({});
      return;
    }

    await UtilTimer.delay(async () => {
      let form = target.closest("form"),
        elements = form.elements,
        fields = ['label-id', 'start-position', 'labels-per-article'],
        serviceLabel = this.labelPrintApi.getServiceLabel(),
        parameter= {};

      fields.forEach((field: string) => {
        if (elements[field] === undefined) {
          console.error("pdf preview field '".concat(field, "' not found!"));
        }

        // set or update value for parameter if its value changed
        if (elements[field] !== undefined && parameter[field] !== elements[field]) {
          parameter[field] = elements[field].value;
        }
      });

      if (this.printListChoice) {
        parameter['items'] = [];
        this.printListChoice.forEach((choiceItem: any) => {
          parameter['items'].push(choiceItem);
        });
      }

      WebComponentLabelPrinting.PARAMETERS = parameter;

      // we write label-id back to template to rerender correct content
      this.printLabelTemplateChoosen = parameter['label-id'];

      // parameter
      if (parameter['label-id'] !== undefined
        && parameter['start-position'] !== undefined
        && parameter['labels-per-article'] !== undefined
        && parameter['items'] !== undefined
      ) {
        let pdfPreview = await serviceLabel.pdfPreview(parameter);
        this.setPdfPreviewData({
          preview: pdfPreview.src,
          articlesCount: pdfPreview.articlesCount,
          printLabelsCount: pdfPreview.printLabelsCount,
          printTemplatesCount: pdfPreview.printTemplatesCount,
          labelsPerSheetCount: pdfPreview.labelsPerSheetCount
        });

        let _labelData = await serviceLabel.get(parameter['label-id']),
          _templates = _labelData['templates'],
          _templateId = _labelData['template-id'];

        this.pdfPreviewTemplate = _templates[_templateId].label;

        if (
          this.pdfPreview
          && this.printPageMaxLabelCountPerSheet !== this.pdfPreview.labelsPerSheetCount
          && this.pdfPreview.labelsPerSheetCount > 1
        ) {
          this.printPageMaxLabelCountPerSheet = this.pdfPreview.labelsPerSheetCount;
        }
      }
    }, WebComponentLabelPrinting.FROM_VALIDATE_DELAY_MILLISECONDS);
  }

  /**
   * setPdfPreviewData
   * @param obj
   * @private
   */
  private setPdfPreviewData(obj: any = {}) {
    this.pdfPreview = {
      preview: '',
      articlesCount: this.printListChoice.length,
      printLabelsCount: '-',
      printTemplatesCount: '-',
      labelsPerSheetCount: 1
    };

    this.pdfPreview = {...this.pdfPreview, ...obj};
  }

  /**
   * delay
   * @param ms
   */
  delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  /**
   * renderRouteLabelOverview
   */
  @RouterRouteRender('LABEL_OVERVIEW')
  async renderRouteLabelOverview(){
    let serviceLabel = this.labelPrintApi.getServiceLabel();

    this.labelOverviewData = await serviceLabel.getAll();
    this.labelPreview = undefined;
  }

  /**
   * renderRouteLabelCreate
   */
  @RouterRouteRender('LABEL_CREATE')
  async renderRouteLabelCreate(){
    Validator.skipNext();
    this.labelPreview = undefined;

    let serviceLabel = this.labelPrintApi.getServiceLabel();
    // @TODO refactor
    let labelData = await serviceLabel.get(0);
    this.lastRenderItem = undefined;
    this.labelTemplates = Object.values(labelData['templates']);
    this.templateLabelWidth = 0;
    this.templateLabelHeight = 0;

    let serviceItem = this.labelPrintApi.getServiceItem();
    this.labelData = await serviceItem.get({
      "source-type": "text",
      "display-type": "text"
    });
    this.labelData = {...this.labelData, ...labelData};

    Validator.skipNext();

    this.labelType = "text";
    this.labelTypeData = "";
    this.labelDisplayType = "text";
    this.labelDisplayTypeOption = "";
    this.labelItems = [];
    this.labelItem = this.labelData['label-items'] ? this.labelData['label-items'][0] : null;

    this.templateId = this.labelData['template-id'];
    this.templateIdOld = this.templateId;
    this.labelPreview = undefined;
  }

  /**
   * renderRouteLabelEdit
   */
  @RouterRouteRender('LABEL_EDIT')
  async renderRouteLabelEdit(props: any){
    Validator.skipNext();
    this.labelPreview = undefined;

    let serviceLabel = this.labelPrintApi.getServiceLabel(),
      id = props.match.params.id;

    this.lastRenderItem = undefined;
    this.templateLabelWidth = 0;
    this.templateLabelHeight = 0;
    this.labelData = await serviceLabel.get(id);
    this.labelTemplates = Object.values(this.labelData['templates']);
    this.labelType = this.labelData.entityValues['source-type'];
    this.labelTypeData = this.labelData.entityValues['source-id'];
    this.labelDisplayType = this.labelData.entityValues['display-type'];
    this.labelItems = this.labelData['label-items'];
    this.labelItem = null;
    this.labelItemDataEntries = {...this.labelItemDataEntries, ...this.labelData.entries};
    this.labelItemIndex = null;

    this.templateId = this.labelData['template-id'];
    this.templateIdOld = this.templateId;
  }

  /**
   * previewHandler
   */
  @Watch('labelData')
  @Watch('labelItemData')
  @Watch('templateLabelWidth')
  @Watch('templateLabelHeight')
  async previewHandler(force = false) {
    if (
      (
        this.previewHandlerRunning ||
        (
          this.labelItem &&
          (
            this.labelItem['item-json']['source-id'] === "" ||
            !this.hasItemChanged(this.labelItem)
          )
        )
      ) &&
      !force
    ) {
      return;
    }
    this.previewHandlerRunning = true;

    if (this.labelData && (this.templateLabelWidth === undefined || (this.templateLabelWidth !== this.labelData['label-width'] && Number.parseFloat(this.labelData['label-width']) > 0))) {
      if (this.labelData['label-width'] !== this.templateLabelWidthOld || this.templateLabelWidthOld === 0) {
        this.templateLabelWidth = this.labelData['label-width'];
      }
    }
    if (this.labelData && (this.templateLabelHeight === undefined || (this.templateLabelHeight !== this.labelData['label-height'] && Number.parseFloat(this.labelData['label-height']) > 0))) {
      if (this.labelData['label-height'] !== this.templateLabelHeightOld || this.templateLabelHeightOld === 0) {
        this.templateLabelHeight = this.labelData['label-height'];
      }
    }

    if (this.templateLabelWidth !== 0 && this.templateLabelHeight !== 0) {
      this.labelPreview = undefined;
      // this delay is needed to prevent caching in browser
      await UtilTimer.delay(async () => {
        if (this.templateLabelWidth !== 0 && this.templateLabelHeight !== 0) {
          let serviceLabel = this.labelPrintApi.getServiceLabel(),
            preview = await serviceLabel.preview({
              'label-width': this.templateLabelWidth,
              'label-height': this.templateLabelHeight,
              'label-items': this.labelData ? this.labelData['label-items'] : []
            });

          this.labelPreview = preview.src;
        }
      }, WebComponentLabelPrinting.AUTO_RENDER_TIMEOUT / 4);
    } else if (this.labelData && (this.templateLabelWidth === 0 || this.templateLabelHeight === 0)) {
      this.templateLabelWidth = this.labelData['label-width'];
      this.templateLabelHeight = this.labelData['label-height'];
    }

    if (this.templateId > 0 && this.labelData && (this.labelData['label-width'] === 0 || this.labelData['label-height'] === 0)) {
      let serviceTemplate = this.labelPrintApi.getServiceTemplate(),
        template = await serviceTemplate.get(this.templateId);

      this.labelData['label-width'] = template['template-json']['label-width'];
      this.labelData['label-height'] = template['template-json']['label-height'];

      this.templateLabelWidth = this.labelData['label-width'];
      this.templateLabelHeight = this.labelData['label-height'];

      this.labelData['label-desc'] = this.templateLabelWidth + 'x' + this.templateLabelHeight;
    }

    this.previewHandlerRunning = false;
  }

  /**
   * previewTemplateHandler
   */
  @Watch('pageTemplateData')
  async previewTemplateHandler() {
    if (this.previewTemplateHandlerRunning) return;
    this.previewTemplateHandlerRunning = true;

    UtilTimer.delay(async () => {
      let serviceTemplate = this.labelPrintApi.getServiceTemplate(),
        form = this.element.shadowRoot.querySelector("form"),
        _preview = "";

      let validate = await Validator.validate(WebComponentLabelPrinting.FORM_IDENTIFIER_TEMPLATE);
      if (validate) {
        let serialized = serviceTemplate.serializeFormData(form);

        if (
          serialized['template-json']
          && Number.parseFloat(serialized['template-json']['width']) > 0
          && Number.parseFloat(serialized['template-json']['height']) > 0
          && serialized['template-json']['page-format'] !== ""
        ) {
          let preview = await serviceTemplate.preview({
            'template-json': serialized['template-json']
          });

          _preview = preview.src;
        }
      }

      this.templatePreview = _preview;
      this.previewTemplateHandlerRunning = false;
    }, WebComponentLabelPrinting.AUTO_RENDER_TIMEOUT);
  }

  /**
   * onChangeTemplateBefore
   * @param event
   */
  @Listen("select:template-id:beforeChange", { target: "window" })
  async onChangeTemplateBefore(event) {
    let id = event.detail.value,
      oldId = event.detail.oldValue,
      serviceTemplate = this.labelPrintApi.getServiceTemplate(),
      template = await serviceTemplate.get(id);

    // check if print template is smaller than current and handle user condition
    if (
      Number.parseFloat(template['template-json']['label-width']) < this.templateLabelWidth ||
      Number.parseFloat(template['template-json']['label-height']) < this.templateLabelHeight
    ) {
      let changePrintTemplate = confirm(this.I18N.t("Die gewählte Druckvorlage ist kleiner als die vorherige. Wenn Sie diese wählen, müssen Sie die Objekte auf dem Etikett anpassen, bevor Sie diese speichern können!"));
      if (!changePrintTemplate) {
        setTimeout(async () => {
          event.detail.instance.setSelectedValue(oldId);
          event.detail.element.setAttribute("data-select-selected", oldId);

          this.templateId = oldId;
          this.labelData['template-id'] = oldId;

          await this.onChangeTemplate(oldId);
        }, 1000);

        return;
      }

      event.detail.element.setAttribute("data-select-selected", id);
      await this.onChangeTemplate(id);

      await this.validateItemsForDimensionDownSize();
    }
  }

  /**
   * onChangeTemplate
   * @param id
   */
  @Listen("select:template-id:afterChange", { target: "window" })
  async onChangeTemplate(id) {
    let idValue = id.detail ? id.detail.value : id,
      serviceTemplate = this.labelPrintApi.getServiceTemplate(),
      template = await serviceTemplate.get(idValue);

    this.templateLabelWidthOld = this.templateLabelWidth;
    this.templateLabelHeightOld = this.templateLabelHeight;

    this.templateLabelWidth = template['template-json']['label-width'];
    this.templateLabelHeight = template['template-json']['label-height'];
    this.templateId = idValue;
    this.templateIdOld = this.templateId;

    if (this.labelData['label-desc'] === "") {
      this.labelData['label-desc'] = this.templateLabelWidth + 'x' + this.templateLabelHeight;
    } else if(this.templateLabelWidthOld !== this.templateLabelWidth || this.templateLabelHeightOld !== this.templateLabelHeight) {
      this.labelData['label-desc'] = this.labelData['label-desc'].replace(
        this.templateLabelWidthOld + 'x' + this.templateLabelHeightOld,
        this.templateLabelWidth + 'x' + this.templateLabelHeight
      );
    }

    this.labelData['label-width'] = this.templateLabelWidth;
    this.labelData['label-height'] = this.templateLabelHeight;

    await this.updateItemData(false);

    if (this.lastRenderItem === undefined) {
      Validator.skipNext();
    }

    await this.autoRenderOnChange(true);
  }

  /**
   * updateLabelDesc
   * @param value
   */
  updateLabelDesc(value: string) {
    if (this.labelData) {
      this.labelData['label-desc'] = value;
    }

    UtilTimer.delay(async () => {
      await this.resetItemForm();

      Validator.skipNext();
      this.labelPrintingLabelFormValid = true;
    }, 1000);
  }

  /**
   * autoRenderOnChange
   */
  @ValidateBefore(WebComponentLabelPrinting.FORM_IDENTIFIER_LABEL, WebComponentLabelPrinting.FROM_VALIDATE_DELAY_MILLISECONDS)
  async autoRenderOnChange(force: boolean = false) {
    let autoRenderOnChange= setTimeout(async ()=> {
      let serializedItem: any,
        _serializedItemForCheck = this.handleItemIdAndDesc();

      if (this.labelItems && this.labelItems[this.labelItemIndex] && this.labelItem && this.labelItem['item-json'] && !force) {
        serializedItem = await this.updateItemForLabel(null, this.labelItemIndex);
      } else if (
        _serializedItemForCheck['item-json']['source-id'] !== "" &&
        !force &&
        (
          _serializedItemForCheck['item-id'] === "" ||
          _serializedItemForCheck['item-id'] == null ||
          _serializedItemForCheck['item-id'] === undefined
        )
      ) {
        serializedItem = await this.addItemToLabel(null);
      }

      if (this.hasItemChanged(serializedItem) || force) {
        await this.previewHandler(force);
      }

      if (this.lastRenderItem === undefined && this.labelItem == null) {
        await this.resetItemForm();
      }

      this.lastRenderItem = serializedItem;

      clearTimeout(autoRenderOnChange);
    }, WebComponentLabelPrinting.AUTO_RENDER_TIMEOUT);
  }

  /**
   * hasItemChanged
   * @param item
   */
  hasItemChanged(item: any) {
    return (
      (
        this.lastRenderItem &&
        (
          item &&
          item['item-id'] !== undefined &&
          item['item-id'] != null &&
          this.lastRenderItem['item-id'] !== undefined &&
          this.lastRenderItem['item-id'] != null &&
          (
            item['item-json'] &&
            item['item-json']['source-id'] !== "" &&
            ((item['item-id'] !== "" && String(this.lastRenderItem['item-id']) !== String(item['item-id'])) || item['item-id'] === "")
          )
        )
      ) ||
      (this.lastRenderItem && item && !AbstractHelpers.deepEqual(this.lastRenderItem, item))
    );
  }

  /**
   * autoRenderTemplateOnChange
   */
  @ValidateBefore(WebComponentLabelPrinting.FORM_IDENTIFIER_TEMPLATE, WebComponentLabelPrinting.FROM_VALIDATE_DELAY_MILLISECONDS)
  async autoRenderTemplateOnChange() {
    UtilTimer.delay(async () => {
      await this.previewTemplateHandler();
    }, WebComponentLabelPrinting.AUTO_RENDER_TIMEOUT);
  }

  /**
   * handleItemIdAndDesc
   * @private
   */
  private handleItemIdAndDesc() {
    let serviceItem = this.labelPrintApi.getServiceItem(),
      form = this.element.shadowRoot.querySelector("form"),
      serializedItem = serviceItem.serializeFormData(form);

    if (
      serializedItem['item-desc'] === undefined
    ) {
      if (serializedItem['item-json']['source-type'] === "placeholder" || serializedItem['item-json']['source-type'] === "feature") {
        let entries = this.labelItemDataEntries[serializedItem['item-json']['source-id']];

        serializedItem['item-desc'] = entries && entries['label'] ? entries['label'] : serializedItem['item-json']['source-id'];
      } else if (serializedItem['item-json']['source-type'] === "text") {
        serializedItem['item-desc'] = serializedItem['item-json']['source-id'];
      }
    }

    if (serializedItem['item-id'] === undefined) {
      serializedItem['item-id'] = "";
    }

    return serializedItem;
  }

  /**
   * addItemToLabel
   */
  @Method()
  async addItemToLabel(e){
    if (e) {
      e.preventDefault();
    }

    let serializedItem = this.handleItemIdAndDesc();

    if (
      serializedItem['item-json'] &&
      serializedItem['item-json']['source-id'] === ""
    ) return;

    if (this.labelItems && !this.hasItemForLabel(serializedItem)) {
      this.labelItems = [...this.labelItems, serializedItem];
      this.labelItemIndex = this.labelItems.length - 1;
      if (this.labelItem) {
        this.labelItem["template-id"] = this.templateId;
      }
      this.labelData['label-items'] = this.labelItems;

      await this.previewHandler();

      await this.loadItemForLabel(null, this.labelItemIndex, false);
    }

    if (e) {
      this.labelItem = null;
      await this.resetItemForm(e);
    }

    return serializedItem;
  }

  /**
   * updateItemForLabel
   */
  @Method()
  async updateItemForLabel(e, index){
    if (e) {
      e.preventDefault();
    }

    let serializedItem = this.handleItemIdAndDesc();

    if (
      !this.labelItems[index] ||
      (
        (
          serializedItem['item-id'] === undefined ||
          serializedItem['item-id'] == null ||
          serializedItem['item-id'] === ""
        ) &&
        serializedItem['item-json'] &&
        serializedItem['item-json']['source-id'] === ""
      )
    ) return;

    if (this.labelItems && !this.hasItemForLabel(serializedItem)) {
      Object.assign(this.labelItems[index], serializedItem);

      this.labelItems = [...this.labelItems];
      this.labelItemIndex = index;
      this.labelData['label-items'] = this.labelItems;

      await this.previewHandler();

      setTimeout(async () => {
        await this.validateItemsForDimensionDownSize();
      }, 1000);
    }

    if (e) {
      this.labelItem = null;

      UtilTimer.delay(async () => {
        await this.resetItemForm(e)

        Validator.skipNext();
        this.labelPrintingLabelFormValid = true;
      }, 1000);
    }

    return serializedItem;
  }

  /**
   * removeItemFromLabel
   */
  @Method()
  async removeItemFromLabel(e, index: number){
    e.preventDefault();

    if (confirm(this.I18N.t("Möchten Sie dieses Element wirklich löschen?"))) {
      this.labelItems.splice(index, 1);
      this.labelItems = [...this.labelItems];
      this.labelItem = null;
      this.labelData['label-items'] = this.labelItems;

      await this.previewHandler();

      UtilTimer.delay(async () => {
        await this.resetItemForm(e)

        Validator.skipNext();
        this.labelPrintingLabelFormValid = true;
      }, 1000);
    }
  }

  /**
   * loadItemForLabel
   */
  @Method()
  async loadItemForLabel(e, index: number, validateAll: boolean = false){
    if(e) e.preventDefault();

    this.labelItemIndex = index;
    this.labelItem = this.labelItems[index];

    if (this.labelItem && this.labelItem['item-json']) {
      this.labelType = this.labelItem['item-json']['source-type'];

      if (this.labelType === "feature") {
        await this.searchFeature();
      }

      this.labelTypeData = this.labelItem['item-json']['source-id'];
      this.labelDisplayType = this.labelItem['item-json']['display-type'];
      this.labelDisplayTypeOption = this.labelItem['item-json']['display-type-sub-option'] || null;

      this.lastRenderItem = this.labelItem;

      await this.updateItemData(false);

      if (validateAll) {
        setTimeout(async () => {
          await this.validateItemsForDimensionDownSize();
        }, 1000);
      }
    }
  }

  /**
   * hasItemForLabel
   */
  hasItemForLabel(item: any) {
    if (this.labelItems === undefined || this.labelItems.length === 0) {
      return false;
    }

    this.labelItems.forEach((_item: any) => {
      if (AbstractHelpers.deepEqual(item, _item)
        || (item['item-id'] && _item['item-id'] && String(item['item-id']) === String(_item['item-id']) && String(_item['item-id']) !== "")) {
        return true;
      }
    })

    return false;
  }

  /**
   * centerItem
   * @param mode
   */
  async centerItem(mode: 'x' | 'y' | undefined) {
    await this.loadItemForLabel(null, this.labelItemIndex, false);

    let modes = {
        x: {
          templateDimension: this.templateLabelWidth / 2,
          itemDimension: Number.parseFloat(this.labelItem['item-json']['width']) / 2
        },
        y: {
          templateDimension: this.templateLabelHeight / 2,
          itemDimension: Number.parseFloat(this.labelItem['item-json']['height']) / 2
        }
      },
      modeData = modes[mode] || null;

    // no mode? center both
    if (modeData == null) {
      modeData = modes['x'];
      this.labelItem['item-json']['x'] = modeData.templateDimension - modeData.itemDimension;
      modeData = modes['y'];
      this.labelItem['item-json']['y'] = modeData.templateDimension - modeData.itemDimension;
      // center only for mode
    } else {
      this.labelItem['item-json'][mode] = modeData.templateDimension - modeData.itemDimension;
    }

    await this.updateItemData(false);
    this.labelItem = {...this.labelItem};
  }

  /**
   * validateItemsForDimensionDownSize
   */
  async validateItemsForDimensionDownSize() {
    this.invalidItems = [];

    this.labelItems.forEach((_item: any) => {
      if (_item['item-id'] !== "") {
        let itemFullSpaceX = Number.parseFloat(_item['item-json']['width']) + Number.parseFloat(_item['item-json']['x']),
          itemFullSpaceY = Number.parseFloat(_item['item-json']['height']) + Number.parseFloat(_item['item-json']['y']);

        if (this.templateLabelWidth < itemFullSpaceX || this.templateLabelHeight < itemFullSpaceY) {
          this.invalidItems = [...this.invalidItems, _item['item-id']];
        }
      }
    });

    if (this.invalidItems.length > 0) {
      let index = this.labelItems.findIndex(item => item['item-id'] === this.invalidItems[0]);
      if (index != null && index !== this.labelItemIndex) {
        await this.loadItemForLabel(null, index, true);
      }
    }
  }

  /**
   * saveLabel
   */
  @Method()
  @ValidateBefore(WebComponentLabelPrinting.FORM_IDENTIFIER_LABEL, WebComponentLabelPrinting.FROM_VALIDATE_DELAY_MILLISECONDS)
  async saveLabel(){
    let serviceLabel = this.labelPrintApi.getServiceLabel(),
      form = this.element.shadowRoot.querySelector("form");

    await serviceLabel.save(form);

    this.pushRouterRoute(this.getRouterRoute('LABEL_OVERVIEW'));
  }

  /**
   * deleteLabel
   * @param id
   */
  @Method()
  async deleteLabel(id: number){
    if (confirm(this.I18N.t("Label wirklich löschen?"))) {
      let serviceLabel = this.labelPrintApi.getServiceLabel();

      await serviceLabel.delete(id);
      this.labelOverviewData = await serviceLabel.getAll();

      let datatable = this.element.shadowRoot.querySelector("dia-datatable") as DiaDatatable;
      await datatable.refreshDataTable();

      this.reloadRouterRoute(this.getRouterRoute('LABEL_OVERVIEW'));
    }
  }

  /**
   * copyLabel
   * @param id
   */
  @Method()
  async copyLabel(id: number){
    if (confirm(this.I18N.t("Label wirklich kopieren?"))) {
      let serviceLabel = this.labelPrintApi.getServiceLabel();

      await serviceLabel.copy(id);
      this.labelOverviewData = await serviceLabel.getAll();

      let datatable= this.element.shadowRoot.querySelector("dia-datatable") as DiaDatatable;
      await datatable.refreshDataTable();

      this.reloadRouterRoute(this.getRouterRoute('LABEL_OVERVIEW'));
    }
  }

  /**
   * editLabel
   * @param id
   */
  @Method()
  async editLabel(id: number){
    this.pushRouterRoute(this.getRouterRoute('LABEL_EDIT', {':id': id}));
  }

  /**
   * renderRoutePageTemplateOverview
   */
  @RouterRouteRender('PAGE_TEMPLATE_OVERVIEW')
  async renderRoutePageTemplateOverview() {
    let serviceTemplate = this.labelPrintApi.getServiceTemplate();

    this.pageTemplateOverviewData = await serviceTemplate.getAll();
  }

  /**
   * renderRoutePageTemplateCreate
   */
  @RouterRouteRender('PAGE_TEMPLATE_CREATE')
  async renderRoutePageTemplateCreate(){
    this.pageTemplateData = undefined;
    this.pageTemplateDataFormat = "";
    this.pageFormat = "";

    let serviceTemplate = this.labelPrintApi.getServiceTemplate(),
      // @ts-ignore
      pageTemplateData = await serviceTemplate.get();

    this.pageTemplateDataFormat = pageTemplateData['page-format'];
    this.pageFormat = "";
    this.templatePreview = "";

    Validator.skipNext();
  }

  /**
   * renderRoutePageTemplateEdit
   */
  @RouterRouteRender('PAGE_TEMPLATE_EDIT')
  async renderRoutePageTemplateEdit(props: any){
    let serviceTemplate = this.labelPrintApi.getServiceTemplate(),
      id = props.match.params.id;

    this.pageTemplateData = await serviceTemplate.get(id);
    this.pageTemplateDataFormat = this.pageTemplateData['page-format'];

    this.pageFormat = this.pageTemplateData['template-json']['page-format'];
    this.templatePreview = "";
  }

  /**
   * savePageTemplate
   */
  @Method()
  @ValidateBefore(WebComponentLabelPrinting.FORM_IDENTIFIER_TEMPLATE, WebComponentLabelPrinting.FROM_VALIDATE_DELAY_MILLISECONDS)
  async savePageTemplate(){
    let serviceTemplate = this.labelPrintApi.getServiceTemplate(),
      form = this.element.shadowRoot.querySelector("form");

    await serviceTemplate.save(form);

    this.pushRouterRoute(this.getRouterRoute('PAGE_TEMPLATE_OVERVIEW'));
  }

  /**
   * editPageTemplate
   * @param id
   */
  @Method()
  async editPageTemplate(id: number) {
    this.pushRouterRoute(this.getRouterRoute('PAGE_TEMPLATE_EDIT', {':id': id}))
  }

  /**
   * copyPageTemplate
   * @param id
   */
  @Method()
  async copyPageTemplate(id: number){
    let serviceTemplate = this.labelPrintApi.getServiceTemplate();

    await serviceTemplate.copy(id);
    this.pageTemplateOverviewData = await serviceTemplate.getAll();

    let datatable= this.element.shadowRoot.querySelector("dia-datatable") as DiaDatatable;
    await datatable.refreshDataTable();

    this.reloadRouterRoute(this.getRouterRoute('PAGE_TEMPLATE_OVERVIEW'));
  }

  /**
   * deletePageTemplate
   * @param id
   */
  @Method()
  async deletePageTemplate(id: number){
    if (confirm(this.I18N.t("Template wirklich löschen?"))) {
      let serviceTemplate = this.labelPrintApi.getServiceTemplate();

      await serviceTemplate.delete(id);
      this.pageTemplateOverviewData = await serviceTemplate.getAll();

      let datatable= this.element.shadowRoot.querySelector("dia-datatable") as DiaDatatable;
      await datatable.refreshDataTable();

      this.reloadRouterRoute(this.getRouterRoute('PAGE_TEMPLATE_OVERVIEW'));
    }
  }

  /**
   * searchFeature
   * @param searchKey
   */
  @Method()
  async searchFeature(searchKey: string = "") {
    let serviceFeature = this.labelPrintApi.getServiceFeature();

    // @ts-ignore
    this.featureResult = await serviceFeature.search(searchKey, this.templateId);

    if (this.featureResult.entries) {
      this.labelItemDataEntries = {...this.labelItemDataEntries, ...this.featureResult.entries};
    }
  }

  /**
   * render
   */
  render() {
    return (
      <WebComponentLabelPrintingTsx ref={this} />
    );
  }
}

/**
 * mixin abstract functions
 */
Object.setPrototypeOf(WebComponentLabelPrinting.prototype, AbstractComponent.prototype);
export interface WebComponentLabelPrinting extends AbstractComponent, RouterRoutable, I18N {}
